var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-medium mega-menu 2xl:top-[2.43rem] 3xl:top-[2.02rem]",class:{ 'mega-menu-on-scroll': _vm.isSticky }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }